import { CompanyTerms } from '@/components/company/CompanyTerms';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Header, withLayout } from '../../components';

const Page: NextPage = () => {
  return withLayout(
    <>
      <NextSeo title="利用規約" />
      <Header />
      <CompanyTerms />
    </>,
  );
};

export default Page;
